import { APP_NAME, LOGO_WHITE } from "@calcom/lib/constants";
import classNames from "@calcom/ui/classNames";

const DEFAULT_SRC = "/api/logo";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = DEFAULT_SRC,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const sizeClass = small ? "h-4 w-auto" : "h-5 w-auto";
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9" alt={APP_NAME} title={APP_NAME} src={`${src}?type=icon`} />
        ) : src === DEFAULT_SRC ? (
          // The brand logo is coloured, so dark mode gets its white variant instead of a CSS invert.
          <>
            <img className={classNames(sizeClass, "dark:hidden")} alt={APP_NAME} title={APP_NAME} src={src} />
            <img
              className={classNames(sizeClass, "hidden dark:inline")}
              alt={APP_NAME}
              title={APP_NAME}
              src={LOGO_WHITE}
            />
          </>
        ) : (
          <img className={classNames(sizeClass, "dark:invert")} alt={APP_NAME} title={APP_NAME} src={src} />
        )}
      </strong>
    </h3>
  );
}
